import { connect } from 'react-redux'

import { setSearchBy } from 'store/entities/gallery/actions'
import { getGallerySearchBy } from 'store/entities/gallery/selectors'
import Search from 'app/components/Search'

import './styles.scss'

const mapStateToProps = state => ({
  value: getGallerySearchBy(state),
  placeHolder: 'Search',
})

const mapDispatchToProps = dispatch => ({
  onChange: e => dispatch(setSearchBy(e && e.target ? e.target.value : '')),
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
